import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import moment from "moment";

interface ExcessOrderGlobalModalProps {
  visible: boolean;
  handleModal: () => void;
  liveInfo?: {
    live_start?: string;
    live_finish?: string;
    live_title?: string;
  };
  excessCount?: number;
}

/**
 * 초과 주문건(재고 초과, 시스템 오류) 발생 시 로그인 직후/대시보드 진입 시 1회 노출되는 전체 알림 팝업.
 * 목업: biz-ttori projects/close/Docs/디자인/초과 주문확인팝업.png
 */
const ExcessOrderGlobalModal = ({
  visible,
  handleModal,
  liveInfo,
  excessCount = 0,
}: ExcessOrderGlobalModalProps) => {
  const Navigate = useNavigate();

  const closeModal = () => handleModal();
  const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
  const go_orderlist = () => {
    handleModal();
    Navigate("/admin/orderlist/payment-wait");
  };

  const startFormatted = liveInfo?.live_start
    ? moment(liveInfo.live_start).format("YYYY.MM.DD HH:mm")
    : "-";
  const finishFormatted = liveInfo?.live_finish
    ? moment(liveInfo.live_finish).format("YYYY.MM.DD HH:mm")
    : "-";

  return (
    <Container data-admin-modal-overlay="" style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox data-admin-modal="" onClick={stopPropagation}>
        <Title data-admin-modal-header="">
          초과 주문건 발생
          <ModalCloseButton tone="admin" aria-label="초과 주문건 닫기" onClick={closeModal} />
        </Title>
        <div data-admin-modal-body=""><SubTitle>시스템 오류로 인해 초과된 주문건이 발생하였습니다.</SubTitle>

        <InfoBox>
          <InfoRow>
            <span className="label">라이브 일시</span>
            <span>
              {startFormatted} ~ {finishFormatted}
            </span>
          </InfoRow>
          <InfoRow>
            <span className="label">라이브 제목</span>
            <span>{liveInfo?.live_title || "-"}</span>
          </InfoRow>
          <InfoRow>
            <span className="label">초과된 주문</span>
            <span>{excessCount}건</span>
          </InfoRow>
        </InfoBox>

        </div><div data-admin-modal-footer=""><GoBtn data-admin-modal-action="" onClick={go_orderlist}>주문내역으로 바로가기</GoBtn></div>
      </ModalBox>
    </Container>
  );
};

export default ExcessOrderGlobalModal;

const Container = styled.div`
  z-index: 100;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: calc(100% - 24px);
  max-width: 400px;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  padding: 30px;
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Title = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  img {
    cursor: pointer;
  }
`;

const SubTitle = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: var(--admin-muted);
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
`;

const InfoBox = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
  span.label {
    width: 90px;
    color: var(--admin-muted);
    flex-shrink: 0;
  }
`;

const GoBtn = styled.div`
  margin-top: 30px;
  padding: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep));
  color: white;
  font-size: 15px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  text-align: center;
  cursor: pointer;
`;
